import { render, staticRenderFns } from "./MctLoading.vue?vue&type=template&id=00622adf&scoped=true&"
import script from "./MctLoading.vue?vue&type=script&lang=js&"
export * from "./MctLoading.vue?vue&type=script&lang=js&"
import style0 from "./MctLoading.vue?vue&type=style&index=0&id=00622adf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00622adf",
  null
  
)

export default component.exports